import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Col, Row } from 'react-bootstrap'
import { useGetTableData } from '../../../../../hooks'
import { isEmpty } from 'lodash'
import DefaultDriverDesktopLayout from '../../../../../components/layout/DefaultDriverDesktopLayout'
import DefaultDriverLayout from 'components/layout/DefaultDriverLayout'
import LoadingSpinner from '../../../../../components/LoadingSpinner'
import moment from 'moment'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { isMobile, numberWithCommas } from 'helpers'
import { partnerHostLive, partnerHostStaging } from '../../../../../constants'
import { getPartnerDetails } from 'actions'
import UpcomingActions from 'components/Partners/UpcomingActions'

//For partner url websites
const isPartnerHost =
  window.location.hostname === partnerHostLive ||
  window.location.hostname === partnerHostStaging
    ? true
    : false
const pathPrefix = isPartnerHost ? '/' : '/partner/'

const HomePage = ({
  history,
  isCarRental,
  isChauffeur,
  isMeetGreet,
  getPartnerDetails,
  isIndependentDriver,
}) => {
  const isMobileBrowser = isMobile()

  let partnerType = localStorage.getItem('partnerType')
    ? localStorage.getItem('partnerType')
    : isCarRental
    ? 'rental'
    : isMeetGreet
    ? 'meetGreet'
    : 'chauffeur'

  const { token } = useParams()
  const [data, setData] = useState({})
  const [name, setName] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)

  const [currentPartnerType, setCurrentPartnerType] = useState(partnerType)

  const {
    data: { list },
  } = useGetTableData(`external/partnerToken/${token}/home-page`)
  console.log('list', list)

  useEffect(() => {
    if (list && list.hasOwnProperty('newOffers')) {
      setData({
        numberOfVehicles: list.vehicles,
        numberOfChauffeurs: list.chauffeurs,
        numberOfGreeters: list.greeters,
        numberOfRentalVehicles: list.rentalVehicles,
        numberOfAgents: list.agents,
        newOffers: list.newOffers,
        upcomingActions: list.upcomingActions,
        newRentalOffers: list.newRentalOffers,
        newMeetGreetOffers: list.newMeetGreetOffers,
        numberOfNewOffers: list.newOffers.length,
        totalEarnings: list.totalEarnings,
        currency: list.currency.toUpperCase(),
        transferCounter: list.transferBookingsCounter,
        transferEarnings: list.transferEarnings,
        hourlyCounter: list.hourlyBookingsCounter,
        carRentalCounter: list.carRentalBookingsCounter,
        meetGreetArrivalCounter: list.meetGreetArrivalCounter,
        meetGreetDepartureCounter: list.meetGreetDepartureCounter,
        meetGreetTransitCounter: list.meetGreetTransitCounter,
        hourlyEarnings: list.hourlyEarnings,
        carRentalEarnings: list.carRentalEarnings,
        meetGreetArrivalEarnings: list.meetGreetArrivalEarnings,
        meetGreetDepartureEarnings: list.meetGreetDepartureEarnings,
        meetGreetTransitEarnings: list.meetGreetTransitEarnings,
        todaysBookings: list.todaysBookings,
        todaysRentalBookings: list.todaysRentalBookings,
        todaysMeetGreetBookings: list.todaysMeetGreetBookings,
        selectRental: list.selectRental,
        selectChauffeur: list.selectChauffeur,
        selectMeetGreet: list.selectMeetGreet,
      })
      const [first_name] = list.userName.split(' ')
      setName(first_name)
    } else if (list && list.userName) {
      const [first_name] = list.userName.split(' ')
      setName(first_name)
    } else if (list && list.newUser) {
      setName('newUser')
    }

    // if (list && list.isIncompleteCompany) {
    //   setShowModal(true)
    // }
  }, [list])

  useEffect(() => {
    const stored = localStorage.getItem('partnerType')
    if (stored && stored !== currentPartnerType) setCurrentPartnerType(stored)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCarRental, isChauffeur, isMeetGreet])

  const togglePartnerType = async type => {
    if (type === currentPartnerType) return
    localStorage.setItem('partnerType', type)
    setCurrentPartnerType(type)
    try {
      await getPartnerDetails(token, type)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (!isEmpty(data)) {
      setIsLoading(false)
    }
  }, [data])

  const renderContent = () => {
    const viewBooking = bookingId => {
      history.push(`${pathPrefix}driver/app/details/${token}/${bookingId}`)
    }

    const viewVIPBooking = (bookingId, type) => {
      history.push(
        `${pathPrefix}driver/app/details/${
          type === 'VIP Meet & Greet, Arrival' ? 'arrival/' : 'departure/'
        }${token}/${bookingId}`
      )
    }
    const viewStandaloneVIPBooking = (bookingId, vipServiceType) => {
      console.log('bookingId', bookingId, vipServiceType)

      history.push(
        `${pathPrefix}driver/app/details/${
          vipServiceType === 'arrival' ? 'arrival/' : 'departure/'
        }${token}/${bookingId}`
      )
    }

    return (
      <>
        {!!isLoading ? (
          <LoadingSpinner />
        ) : (
          <div
            className='d-flex driver-booking-container'
            style={{ margin: 0 }}
          >
            {data && name ? (
              <>
                {/* New offers */}
                {partnerType === 'chauffeur' ? (
                  <Col
                    md={6}
                    style={{ height: 'fit-content' }}
                    // className='driver-service-card'
                  >
                    <div className='driver-service-card'>
                      <span className='driver-service-card-header mb-4'>
                        Today
                      </span>
                      <div>
                        <div className='d-flex mb-4'>
                          <div className='align-self-center'>
                            <img
                              src='/images/icons/icon-bookings-gold.png'
                              alt=''
                              width={25}
                            />
                          </div>
                          <div
                            className='d-flex flex-column'
                            style={{ paddingLeft: '1.7rem' }}
                          >
                            <span className='counter'>
                              {data.todaysBookings.length}
                            </span>
                            <span className='card-message'>Bookings</span>
                          </div>
                        </div>
                      </div>
                      <>
                        {data && data.todaysBookings
                          ? data.todaysBookings.map(item => (
                              <div className='grey-background'>
                                <Row>
                                  <Col md={6}>
                                    <span className='offer-date'>
                                      {moment
                                        .utc(item.date)
                                        .format('ddd D MMM YY, HH:mm')}
                                    </span>
                                  </Col>
                                </Row>
                                <Row className='mt-1'>
                                  <Col className='pt-1'>
                                    {item.status === 'confirmed' ||
                                    item.status === 'change_request' ||
                                    item.status === 'completed' ? (
                                      <span className='newOffer-message'>
                                        {`${item.type} • ${item.passengerName}`}
                                      </span>
                                    ) : (
                                      <span className='newOffer-message'>
                                        {item.type}
                                      </span>
                                    )}
                                    <span className='newOffer-message pt-1'>
                                      {item.vehicle}
                                    </span>
                                  </Col>
                                  <div
                                    // md={6}
                                    className='d-flex justify-content-end col-md-auto pt-1'
                                  >
                                    <Button
                                      className='partner-btn-desktop-primary select-vehicle'
                                      variant='brown'
                                      onClick={() => {
                                        if (item?.isStandaloneVip) {
                                          viewStandaloneVIPBooking(
                                            item?.bookingId,
                                            item?.vipServiceType
                                          )
                                        } else {
                                          viewBooking(item.bookingId)
                                        }
                                      }}
                                    >
                                      View
                                    </Button>
                                  </div>
                                </Row>
                              </div>
                            ))
                          : ''}
                      </>
                    </div>
                    <div className='driver-service-card'>
                      <span className='driver-service-card-header mb-4'>
                        New offers
                      </span>
                      {isIndependentDriver &&
                      data?.newOffers &&
                      data?.newOffers.length > 0 ? (
                        <>
                          {Object.entries(
                            data.newOffers.reduce((acc, item) => {
                              const key =
                                item.supplierName !== list?.company?.name
                                  ? item.supplierName
                                  : 'ROLZO'
                              if (!acc[key]) acc[key] = []
                              acc[key].push(item)
                              return acc
                            }, {})
                          ).map(([supplierName, offers], idx) => (
                            <div
                              key={supplierName}
                              style={
                                idx > 0 ? { marginTop: '1.5em' } : undefined
                              }
                            >
                              <div className='d-flex justify-content-between mb-4'>
                                <div style={{ display: 'flex' }}>
                                  <div className='align-self-center'>
                                    <img
                                      src='/images/icons/icon-bookings-gold.png'
                                      alt=''
                                      width={25}
                                    />
                                  </div>
                                  <div
                                    className='d-flex flex-column'
                                    style={{ paddingLeft: '1.7rem' }}
                                  >
                                    <span className='counter'>
                                      {offers.length}
                                    </span>
                                    <span className='card-message'>
                                      New offers
                                    </span>
                                  </div>
                                </div>
                                <div className='d-flex align-items-center ms-auto'>
                                  <span className='supplier-tag'>
                                    FROM {supplierName.toUpperCase()}
                                  </span>
                                </div>
                              </div>
                              {offers.map((item, idx) => (
                                <div key={idx} className='grey-background'>
                                  <Row>
                                    <Col md={6}>
                                      <span className='offer-date'>
                                        {moment
                                          .utc(item.date)
                                          .format('ddd D MMM YY, HH:mm')}
                                      </span>
                                    </Col>
                                    {supplierName === 'ROLZO' ? (
                                      <Col
                                        md={6}
                                        className='d-flex justify-content-end'
                                      >{`${numberWithCommas(
                                        parseFloat(item.price).toFixed(2)
                                      )} ${item.currency}`}</Col>
                                    ) : (
                                      <></>
                                    )}
                                  </Row>
                                  <Row className='mt-1'>
                                    <Col md={6} className='pt-1'>
                                      <span className='newOffer-message'>
                                        {item.type}
                                      </span>
                                      <span className='newOffer-message pt-1'>
                                        {item.vehicle}
                                      </span>
                                    </Col>
                                    <Col
                                      md={6}
                                      className='d-flex justify-content-end pt-1'
                                    >
                                      <Button
                                        className='partner-btn-desktop-primary select-vehicle'
                                        variant='brown'
                                        onClick={() => {
                                          viewBooking(item.bookingId)
                                        }}
                                      >
                                        View
                                      </Button>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                            </div>
                          ))}
                        </>
                      ) : (
                        <>
                          <div>
                            <div className='d-flex mb-4'>
                              <div className='align-self-center'>
                                <img
                                  src='/images/icons/icon-bookings-gold.png'
                                  alt=''
                                  width={25}
                                />
                              </div>
                              <div
                                className='d-flex flex-column'
                                style={{ paddingLeft: '1.7rem' }}
                              >
                                <span className='counter'>
                                  {data.numberOfNewOffers}
                                </span>
                                <span className='card-message'>New offers</span>
                              </div>
                            </div>
                          </div>
                          <>
                            {data && data.newOffers
                              ? data.newOffers.map(item => (
                                  <div className='grey-background'>
                                    <Row>
                                      <Col md={6}>
                                        <span className='offer-date'>
                                          {moment
                                            .utc(item.date)
                                            .format('ddd D MMM YY, HH:mm')}
                                        </span>
                                      </Col>
                                      <Col
                                        md={6}
                                        className='d-flex justify-content-end'
                                      >{`${numberWithCommas(
                                        parseFloat(item.price).toFixed(2)
                                      )} ${item.currency}`}</Col>
                                    </Row>
                                    <Row className='mt-1'>
                                      <Col md={6} className='pt-1'>
                                        <span className='newOffer-message'>
                                          {item.type}
                                        </span>
                                        <span className='newOffer-message pt-1'>
                                          {item.vehicle}
                                        </span>
                                      </Col>
                                      <Col
                                        md={6}
                                        className='d-flex justify-content-end pt-1'
                                      >
                                        <Button
                                          className='partner-btn-desktop-primary select-vehicle'
                                          variant='brown'
                                          onClick={() => {
                                            viewBooking(item.bookingId)
                                          }}
                                        >
                                          View
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div>
                                ))
                              : ''}
                          </>
                        </>
                      )}
                    </div>
                  </Col>
                ) : partnerType === 'meetGreet' ? (
                  <Col
                    md={6}
                    style={{ height: 'fit-content' }}
                    // className='driver-service-card'
                  >
                    <div className='driver-service-card'>
                      <span className='driver-service-card-header mb-4'>
                        Today
                      </span>
                      <div>
                        <div className='d-flex mb-4'>
                          <div className='align-self-center'>
                            <img
                              src='/images/icons/icon-bookings-gold.png'
                              alt=''
                              width={25}
                            />
                          </div>
                          <div
                            className='d-flex flex-column'
                            style={{ paddingLeft: '1.7rem' }}
                          >
                            <span className='counter'>
                              {data.todaysMeetGreetBookings.length}
                            </span>
                            <span className='card-message'>Bookings</span>
                          </div>
                        </div>
                      </div>
                      <>
                        {data && data.todaysMeetGreetBookings
                          ? data.todaysMeetGreetBookings.map(item => (
                              <div className='grey-background'>
                                <Row>
                                  <Col md={6}>
                                    <span className='offer-date'>
                                      {moment
                                        .utc(item.date)
                                        .format('ddd D MMM YY, HH:mm')}
                                    </span>
                                  </Col>
                                  {/* <Col
                                    md={6}
                                    className='d-flex justify-content-end'
                                  >{`${item.price} ${item.currency}`}</Col> */}
                                </Row>
                                <Row className='mt-1'>
                                  <Col className='pt-1'>
                                    {item.status === 'confirmed' ||
                                    item.status === 'change_request' ||
                                    item.status === 'completed' ? (
                                      <span className='newOffer-message'>
                                        {`${item.type} • ${item.passengerName}`}
                                      </span>
                                    ) : (
                                      <span className='newOffer-message'>
                                        {item.type}
                                      </span>
                                    )}
                                  </Col>
                                  <div
                                    // md={6}
                                    className='d-flex justify-content-end col-md-auto pt-1'
                                  >
                                    <Button
                                      className='partner-btn-desktop-primary select-vehicle'
                                      variant='brown'
                                      onClick={() => {
                                        if (item?.isStandaloneVip) {
                                          viewVIPBooking(
                                            item.bookingId,
                                            item.type
                                          )
                                        } else {
                                          viewBooking(item.bookingId)
                                        }
                                      }}
                                    >
                                      View
                                    </Button>
                                  </div>
                                </Row>
                              </div>
                            ))
                          : ''}
                      </>
                    </div>
                    <div className='driver-service-card'>
                      <span className='driver-service-card-header mb-4'>
                        New offers
                      </span>
                      <div>
                        <div className='d-flex mb-4'>
                          <div className='align-self-center'>
                            <img
                              src='/images/icons/icon-bookings-gold.png'
                              alt=''
                              width={25}
                            />
                          </div>
                          <div
                            className='d-flex flex-column'
                            style={{ paddingLeft: '1.7rem' }}
                          >
                            <span className='counter'>
                              {data.newMeetGreetOffers.length}
                            </span>
                            <span className='card-message'>New offers</span>
                          </div>
                        </div>
                      </div>
                      <>
                        {data && data.newMeetGreetOffers
                          ? data.newMeetGreetOffers.map(item => (
                              <div className='grey-background'>
                                <Row>
                                  <Col md={6}>
                                    <span className='offer-date'>
                                      {moment
                                        .utc(item.date)
                                        .format('ddd D MMM YY, HH:mm')}
                                    </span>
                                  </Col>
                                  <Col
                                    md={6}
                                    className='d-flex justify-content-end'
                                  >{`${numberWithCommas(
                                    parseFloat(item.price).toFixed(2)
                                  )} ${item.currency}`}</Col>
                                </Row>
                                <Row className='mt-1'>
                                  <Col md={6} className='pt-1'>
                                    <span className='newOffer-message'>
                                      {item.type}
                                    </span>
                                    {item.iata ? (
                                      <span className='newOffer-message pt-1'>
                                        {item.iata}
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </Col>
                                  <Col
                                    md={6}
                                    className='d-flex justify-content-end pt-1'
                                  >
                                    <Button
                                      className='partner-btn-desktop-primary select-vehicle'
                                      variant='brown'
                                      onClick={() => {
                                        if (item?.isStandaloneVip) {
                                          viewStandaloneVIPBooking(
                                            item?.bookingId,
                                            item?.vipServiceType
                                          )
                                        } else {
                                          viewVIPBooking(
                                            item.bookingId,
                                            item.type
                                          )
                                        }
                                      }}
                                    >
                                      View
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            ))
                          : ''}
                      </>
                    </div>
                  </Col>
                ) : (
                  <Col
                    md={6}
                    style={{ height: 'fit-content' }}
                    // className='driver-service-card'
                  >
                    <div className='driver-service-card'>
                      <span className='driver-service-card-header mb-4'>
                        Today
                      </span>
                      <div>
                        <div className='d-flex mb-4'>
                          <div className='align-self-center'>
                            <img
                              src='/images/icons/icon-bookings-gold.png'
                              alt=''
                              width={25}
                            />
                          </div>
                          <div
                            className='d-flex flex-column'
                            style={{ paddingLeft: '1.7rem' }}
                          >
                            <span className='counter'>
                              {data.todaysRentalBookings.length}
                            </span>
                            <span className='card-message'>Bookings</span>
                          </div>
                        </div>
                      </div>
                      <>
                        {data && data.todaysRentalBookings
                          ? data.todaysRentalBookings.map(item => (
                              <div className='grey-background'>
                                <Row>
                                  <Col md={6}>
                                    <span className='offer-date'>
                                      {moment
                                        .utc(item.date)
                                        .format('ddd D MMM YY, HH:mm')}
                                    </span>
                                  </Col>
                                  {/* <Col
                                    md={6}
                                    className='d-flex justify-content-end'
                                  >{`${item.price} ${item.currency}`}</Col> */}
                                </Row>
                                <Row className='mt-1'>
                                  <Col className='pt-1'>
                                    {item.status === 'confirmed' ||
                                    item.status === 'change_request' ||
                                    item.status === 'completed' ? (
                                      <span className='newOffer-message'>
                                        {`${item.type} • ${item.passengerName}`}
                                      </span>
                                    ) : (
                                      <span className='newOffer-message'>
                                        {item.type}
                                      </span>
                                    )}
                                    <span className='newOffer-message pt-1'>
                                      {item.vehicle}
                                    </span>
                                  </Col>
                                  <div
                                    // md={6}
                                    className='d-flex justify-content-end col-md-auto pt-1'
                                  >
                                    <Button
                                      className='partner-btn-desktop-primary select-vehicle'
                                      variant='brown'
                                      onClick={() => {
                                        if (item.isStandaloneVip) {
                                          viewStandaloneVIPBooking(
                                            item.bookingId,
                                            item.vipServiceType
                                          )
                                        } else {
                                          viewBooking(item.bookingId)
                                        }
                                      }}
                                    >
                                      View
                                    </Button>
                                  </div>
                                </Row>
                              </div>
                            ))
                          : ''}
                      </>
                    </div>
                    <div className='driver-service-card'>
                      <span className='driver-service-card-header mb-4'>
                        New offers
                      </span>
                      <div>
                        <div className='d-flex mb-4'>
                          <div className='align-self-center'>
                            <img
                              src='/images/icons/icon-bookings-gold.png'
                              alt=''
                              width={25}
                            />
                          </div>
                          <div
                            className='d-flex flex-column'
                            style={{ paddingLeft: '1.7rem' }}
                          >
                            <span className='counter'>
                              {data.newRentalOffers &&
                              data.newRentalOffers.length
                                ? data.newRentalOffers.length
                                : 0}
                            </span>
                            <span className='card-message'>New offers</span>
                          </div>
                        </div>
                      </div>
                      <>
                        {data && data.newRentalOffers
                          ? data.newRentalOffers.map(item => (
                              <div className='grey-background'>
                                <Row>
                                  <Col md={6}>
                                    <span className='offer-date'>
                                      {moment
                                        .utc(item.date)
                                        .format('ddd D MMM YY, HH:mm')}
                                    </span>
                                  </Col>
                                  <Col
                                    md={6}
                                    className='d-flex justify-content-end'
                                  >{`${numberWithCommas(
                                    parseFloat(item.price).toFixed(2)
                                  )} ${item.currency}`}</Col>
                                </Row>
                                <Row className='mt-1'>
                                  <Col md={6} className='pt-1'>
                                    <span className='newOffer-message'>
                                      {item.type}
                                    </span>
                                    <span className='newOffer-message pt-1'>
                                      {item.vehicle}
                                    </span>
                                  </Col>
                                  <Col
                                    md={6}
                                    className='d-flex justify-content-end pt-1'
                                  >
                                    <Button
                                      className='partner-btn-desktop-primary select-vehicle'
                                      variant='brown'
                                      onClick={() => {
                                        viewBooking(item.bookingId)
                                      }}
                                    >
                                      View
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            ))
                          : ''}
                      </>
                    </div>
                  </Col>
                )}
                <Col md={6}>
                  {/* Upcoming actions card */}
                  <div className='driver-service-card'>
                    <span className='driver-service-card-header mb-4'>
                      Upcoming actions
                    </span>
                    {data.upcomingActions && data.upcomingActions.length ? (
                      <UpcomingActions
                        viewBooking={viewBooking}
                        actions={(() => {
                          if (partnerType === 'rental') {
                            return data.upcomingActions.filter(
                              action => action.type === 'car_rentals'
                            )
                          } else if (partnerType === 'meetGreet') {
                            return data.upcomingActions.filter(
                              action => action.type === 'meet_and_greet'
                            )
                          } else {
                            return data.upcomingActions.filter(
                              action =>
                                action.type !== 'car_rentals' &&
                                action.type !== 'meet_and_greet'
                            )
                          }
                        })()}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* Total earnings card */}
                  <div className='driver-service-card'>
                    <span className='driver-service-card-header mb-4'>
                      Earnings
                    </span>
                    <div className='d-flex '>
                      <div className='align-self-center'>
                        <img
                          src='/images/icons/icon-earnings.png'
                          alt=''
                          width={25}
                        />
                      </div>
                      <div
                        className='d-flex flex-column'
                        style={{ paddingLeft: '2.7rem' }}
                      >
                        <span className='counter'>{`${numberWithCommas(
                          numberWithCommas(
                            parseFloat(
                              partnerType === 'rental'
                                ? data.carRentalEarnings
                                : partnerType === 'meetGreet'
                                ? parseFloat(data.meetGreetArrivalEarnings) +
                                  parseFloat(data.meetGreetDepartureEarnings) +
                                  parseFloat(data.meetGreetTransitEarnings || 0)
                                : parseFloat(data.totalEarnings) -
                                  parseFloat(data.carRentalEarnings)
                            ).toFixed(2)
                          )
                        )} ${data.currency}`}</span>
                        <span className='card-message'>Total earnings</span>
                      </div>
                    </div>
                    {partnerType === 'chauffeur' ? (
                      <>
                        <div className='chauffeur-card-item'>
                          <span className='partner-bookingType'>{`Transfers (${data.transferCounter}) `}</span>
                          <span>{`${numberWithCommas(
                            numberWithCommas(
                              parseFloat(data.transferEarnings).toFixed(2)
                            )
                          )} ${data.currency}`}</span>
                        </div>
                        <div className='chauffeur-card-item'>
                          <span className='partner-bookingType'>{`By the hour (${data.hourlyCounter}) `}</span>
                          <span>{`${numberWithCommas(
                            numberWithCommas(
                              parseFloat(data.hourlyEarnings).toFixed(2)
                            )
                          )} ${data.currency}`}</span>
                        </div>
                      </>
                    ) : partnerType === 'meetGreet' ? (
                      <>
                        <div className='chauffeur-card-item'>
                          <span className='partner-bookingType'>{`VIP Meet & Greet, Arrival (${data.meetGreetArrivalCounter}) `}</span>
                          <span>{`${numberWithCommas(
                            numberWithCommas(
                              parseFloat(data.meetGreetArrivalEarnings).toFixed(
                                2
                              )
                            )
                          )} ${data.currency}`}</span>
                        </div>
                        <div className='chauffeur-card-item'>
                          <span className='partner-bookingType'>{`VIP Meet & Greet, Departure (${data.meetGreetDepartureCounter}) `}</span>
                          <span>{`${numberWithCommas(
                            numberWithCommas(
                              parseFloat(
                                data.meetGreetDepartureEarnings
                              ).toFixed(2)
                            )
                          )} ${data.currency}`}</span>
                        </div>
                        <div className='chauffeur-card-item'>
                          <span className='partner-bookingType'>{`VIP Meet & Greet, Transit (${data.meetGreetTransitCounter}) `}</span>
                          <span>{`${numberWithCommas(
                            numberWithCommas(
                              parseFloat(
                                data.meetGreetTransitEarnings || 0
                              ).toFixed(2)
                            )
                          )} ${data.currency}`}</span>
                        </div>
                      </>
                    ) : (
                      <div className='chauffeur-card-item'>
                        <span className='partner-bookingType'>{`Car rental (${data.carRentalCounter}) `}</span>
                        <span>{`${numberWithCommas(
                          numberWithCommas(
                            parseFloat(data.carRentalEarnings).toFixed(2)
                          )
                        )} ${data.currency}`}</span>
                      </div>
                    )}
                  </div>
                  {/* Chauffeur card */}
                  {!list?.company?.isIndependentDriver &&
                    (() => {
                      const partnerConfig = {
                        rental: {
                          label: 'Agents',
                          count: data.numberOfAgents,
                          message: 'Active agents',
                        },
                        meetGreet: {
                          label: 'Greeters',
                          count: data.numberOfGreeters,
                          message: 'Active greeters',
                        },
                      }
                      const { label, count, message } = partnerConfig[
                        partnerType
                      ] ?? {
                        label: 'Chauffeurs',
                        count: data.numberOfChauffeurs,
                        message: 'Active chauffeurs',
                      }
                      return (
                        <div className='driver-service-card'>
                          <span className='driver-service-card-header mb-4'>
                            {label}
                          </span>
                          <div className='d-flex '>
                            <div className='align-self-center'>
                              <img
                                src='/images/icons/icon-chauffeur-gold.png'
                                alt=''
                                width={25}
                              />
                            </div>
                            <div
                              className='d-flex flex-column'
                              style={{ paddingLeft: '2.7rem' }}
                            >
                              <span className='counter'>{count}</span>
                              <span className='card-message'>{message}</span>
                            </div>
                          </div>
                        </div>
                      )
                    })()}
                  {/* Vehicle card */}
                  {partnerType !== 'meetGreet' && (
                    <div className='driver-service-card'>
                      <span className='driver-service-card-header mb-3'>
                        Vehicles
                      </span>
                      <div className='d-flex '>
                        <div className='align-self-center'>
                          <img
                            style={{ verticalAlign: 'bottom' }}
                            src='/images/icons/icon-vehicle-gold.png'
                            alt=''
                            width={40}
                          />
                        </div>

                        <div
                          className='d-flex flex-column'
                          style={{ paddingLeft: '1.9rem' }}
                        >
                          <span className='counter'>
                            {partnerType === 'rental'
                              ? data.numberOfRentalVehicles
                              : data.numberOfVehicles}
                          </span>
                          <span className='card-message'>Active vehicles</span>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </>
            ) : (
              <LoadingSpinner />
            )}
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {isMobileBrowser ? (
        <DefaultDriverLayout
          data={[list]}
          userName={name}
          togglePartnerType={togglePartnerType}
          currentPartnerType={currentPartnerType}
          isIndependentDriver={isIndependentDriver}
        />
      ) : (
        <DefaultDriverDesktopLayout
          // data={list}
          renderContent={renderContent}
          userName={name}
          togglePartnerType={togglePartnerType}
          currentPartnerType={currentPartnerType}
          isIndependentDriver={isIndependentDriver}
        />
      )}
    </>
  )
}

const mapStateToProps = ({
  auth: {
    isCarRental = null,
    isChauffeur = null,
    isMeetGreet = null,
    isIndependentDriver,
  },
  appWebsocket,
}) => ({
  isCarRental,
  isChauffeur,
  isMeetGreet,
  showComPopup: appWebsocket.showComPopup,
  isIndependentDriver,
})

export default withRouter(
  connect(mapStateToProps, { getPartnerDetails })(HomePage)
)
